import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { BehaviorSubject, Subscription, combineLatest, tap } from 'rxjs';
import { IUser } from 'src/app/shared/models/user/user.model';
import { UserNameOrEmailPipe } from 'src/app/shared/pipes/user-name-or-email.pipe';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IUserState, UserStoreService } from 'src/app/shared/services/store/user-store.service';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';

@Component({
  selector: 'app-user-menu-item',
  standalone: true,
  imports: [CommonModule, UserAvatarComponent, UserNameOrEmailPipe, MenuModule],
  templateUrl: './user-menu-item.component.html',
  styleUrls: ['./user-menu-item.component.scss']
})
export class UserMenuItemComponent implements OnInit, OnDestroy {

  @Input() showName: boolean = true;
  @Input() signOutWithoutRedirect: boolean | undefined;

  user$ = new BehaviorSubject<IUser | null>(null);
  userState: IUserState | undefined;

  items: MenuItem[] = [];

  user: any;

  subs: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private nameEmailPipe: UserNameOrEmailPipe,
    public userStore: UserStoreService,
    private navService: NavigationService,
    private translate: TranslateService,
    public selectedOrg: SelectedOrgService,
  ) { }

  ngOnInit(): void {
    this.userState = this.userStore.state;

    this.createMenuItems();

    this.subs.push(
      this.userState.user$.subscribe(user => { this.createMenuItems(); }),

      this.translate.onLangChange.subscribe(() => { this.createMenuItems(); })
    );
  }

  private createMenuItems() {
    const user = this.userState?.user$.value;
    if (user) {
      const userItem: MenuItem = {
        label: this.nameEmailPipe.transform(user?.orgUsers ?? [], this.selectedOrg.getCurrentValue(), true),
        items: [
          {
            label: this.translate.instant('admin.user-menu-item.account-settings.label'),
            icon: 'pi pi-cog',
            command: () => this.navService.goToUserAccountSettings()
          },
          {
            label: this.translate.instant('admin.user-menu-item.sign-out.label'),
            icon: 'pi pi-sign-out',
            command: () => this.authService.signOut(this.signOutWithoutRedirect)
          }
        ]
      };
      this.items = [ userItem ];
    } else {
      this.items = [];
    }

  }

  findMenuItemById(id: string) {
    return this.items.find(x => x.id === id);
  }


  ngOnDestroy(): void {
    this.subs.forEach(x => x.unsubscribe());
  }
}
